<template>
  <div class="carousel-entry">
    <div v-if="image" class="carousel-entry__image-wrap">
      <img :src="image" :alt="title" class="carousel-entry__image" />
    </div>
    <div class="carousel-entry__main">
      <h3 v-if="title" class="carousel-entry__title">
        {{ title }}
      </h3>
      <a
        v-if="categoryTitle && categoryLink"
        :href="categoryLink"
        class="carousel-entry__category"
        @click.prevent="navigateTo(categoryLink)"
        >{{ categoryTitle }}</a
      >
      <span v-if="categoryTitle && !categoryLink" class="carousel-entry__category">{{
        categoryTitle
      }}</span>
      <a
        v-if="link"
        :href="link"
        class="button button--sub-small button--secondary-inversed-mono carousel-entry__button"
        @click.prevent="navigateTo(link)"
        >{{ buttonText }}</a
      >
    </div>
  </div>
</template>

<script>
import { useNavigation } from '@/composables/useNavigation'
export default {
  name: 'CarouselEntry',
  props: {
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    categoryTitle: {
      type: String,
      default: '',
    },
    categoryLink: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'View Product',
    },
  },
  setup() {
    const { navigateTo } = useNavigation()

    return {
      navigateTo,
    }
  },
}
</script>
